import { useQuery } from '@tanstack/react-query';

import { useSnackbar } from '@/features/snackbar';

import { queryFn } from './queryFn';

type Args = {
  brokerageId: string;
  onSuccess?(d: Awaited<ReturnType<typeof queryFn>>): void;
  onError?(): void;
};

export function useGeneratePortfolioLinkUrl({
  brokerageId,
  onError,
  onSuccess,
}: Args) {
  const { addSnackbar } = useSnackbar();
  return useQuery({
    queryKey: ['PORTFOLIO_LINK_URL', brokerageId],
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    onSuccess,
    onError() {
      onError?.();
      addSnackbar({
        type: 'negative',
        message: 'Failed to connect',
        lifeTime: 2000,
      });
    },
  });
}
